import {
    SmallTextHelper
} from '../PrismicHelpers';

export const membersPageHelper = (response) => {
    const membersData = response.result;
    let memberObject = membersData.map(member => {
        return {
            uid: SmallTextHelper(member.id),
            member_title: SmallTextHelper(member.data.members_page_title),
            member_summary: SmallTextHelper(member.data.members_summary),
            member_summary_label: SmallTextHelper(member.data.members_redirect_label),
            member_summary_path: SmallTextHelper(member.data.members_redirect_path),
        }
    })
    return memberObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/MembersPageHelper.js